import { createKeyedDataAsyncSlice } from '../createKeyedDataAsyncSlice';
import { updateClientOrderByIdAsync } from '../../API/clientPortal/clientOrderAPI';

export const { slice: updateClientSlice, asyncAction: updateClientUpdateAction } =
  createKeyedDataAsyncSlice('updateClient', updateClientOrderByIdAsync, ({ id }) => `${id}`);
